import type { FC } from 'react';

export const EmptyLink: FC = ({ children }) => {
  return <div className="py-4 text-center text-t2 text-grey4">{children}</div>;
};
